module.exports = __webpack_public_path__ + "static/media/setu.9c06cd88.png";